/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_IdInputs */

const en_tracking_id = /** @type {(inputs: Tracking_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking ID`)
};

const es_tracking_id = /** @type {(inputs: Tracking_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de Seguimiento`)
};

const fr_tracking_id = /** @type {(inputs: Tracking_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de suivi`)
};

const de_tracking_id = /** @type {(inputs: Tracking_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking-ID`)
};

const id_tracking_id = /** @type {(inputs: Tracking_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Pelacakan`)
};

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const ja_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const zh_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const ar_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const it_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const ru_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const pt_tracking_id = en_tracking_id;

/** @type {(inputs: Tracking_IdInputs) => LocalizedString} */
const ko_tracking_id = en_tracking_id;

/**
* | output |
* | --- |
* | "Tracking ID" |
*
* @param {Tracking_IdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tracking_id = /** @type {((inputs?: Tracking_IdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_IdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tracking_id(inputs)
	if (locale === "es") return es_tracking_id(inputs)
	if (locale === "fr") return fr_tracking_id(inputs)
	if (locale === "de") return de_tracking_id(inputs)
	if (locale === "ja") return ja_tracking_id(inputs)
	if (locale === "zh") return zh_tracking_id(inputs)
	if (locale === "ar") return ar_tracking_id(inputs)
	if (locale === "id") return id_tracking_id(inputs)
	if (locale === "it") return it_tracking_id(inputs)
	if (locale === "ru") return ru_tracking_id(inputs)
	if (locale === "pt") return pt_tracking_id(inputs)
	return ko_tracking_id(inputs)
});